import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getAllLanguagesForPersons = (detailed) => dispatch => {
  dispatch({ type: "GET_ALL_LANGUAGES_LOADING" });
  api
    .languagesGetAllForPersons(detailed)
    .then(resp => {
      dispatch(operationSucceeded(resp.data));
        //dispatch({ type: "GET_ALL_LANGUAGES_LOADING_DONE" });
    })
    .catch(e => {
      jsError(e);
      dispatch({ type: "GET_ALL_LANGUAGES_LOADING_DONE" });
      dispatch(operationFail());
      dispatch(buildAlertWithLocalizedMessages(
        "ERROR",
        "GetAllLanguagesErrorAlertTitle",
        "Virhe kielitaitojen haussa",
        e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
    });
};

const operationSucceeded = data => ({
  type: "GET_ALL_LANGUAGES_SUCCEEDED",
  payload: { languages: data },
});

const operationFail = () => ({
  type: "GET_ALL_LANGUAGES_FAIL",
});
